// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__3UIDS","mde-logo":"footer_mde-logo__EuTsq","info":"footer_info__xd0PQ","online":"footer_online__3wtwA"};